import PropTypes from "prop-types";
import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
// Pages Components
import LatestTranaction from "./Policies";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//i18n
import { withTranslation } from "react-i18next";
import DocsTooltip from "components/Common/DocsTooltip";

const OnCallPolicyList = props => {
    //meta title
    document.title = "On-Call Policies | Temperstack";
    const [tooltip, setTooltip] = useState(false);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg="10">
                            <div className="d-flex gap-1">
                                <Breadcrumbs
                                    title={props.t("On-Call Policies")}
                                    breadcrumbItem={props.t("On-Call Policies")}
                                />
                                <span role="button" id='oncallTooltip'>
                                    <i className="bx bx-help-circle font-size-16 text-white" />
                                </span>
                                <DocsTooltip 
                                 placement={'right'}
                                 isOpen={tooltip}
                                 toggle={() => setTooltip(!tooltip)}
                                 targetId={'oncallTooltip'}
                                 linkText={'On-call scheduling'}
                                 link={'https://docs.temperstack.com/temperstack/platform/incident-command/on-call-scheduling-and-escalation-policies'}
                                />
                            </div>
                        </Col>
                        <Col lg="2">
                            <Link
                                to="/oncall-policies/create"
                                className="btn btn-primary bx-pull-right w-md"
                            >
                                Add On-Call Policy
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <LatestTranaction />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

OnCallPolicyList.propTypes = {
    t: PropTypes.any,
    // chartsData: PropTypes.any,
    // onGetChartsData: PropTypes.func,
};

export default withTranslation()(OnCallPolicyList);
